import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { FieldLabelWrapperStyleStates } from './types';

const styles = {
  root: css``,
} satisfies Styles<FieldLabelWrapperStyleStates>;

export const useStyles = withStyles(styles);
